import { gameCards } from "@/mocks/home";

export default function Playground() {
  return (
    <section id="play" className="w-full bg-background-50 py-14 md:py-20">
      <div className="shell">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="sec-eyebrow">Pick your lane</p>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-950 md:text-4xl">
              四种吃法，总有一种
              <span className="text-primary-600">把你难住</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              按你的节奏选择入口——想随手刷就进答题，想认清自己就做测试，够胆就来连答闯关，资深党直接开卷考古考察。
            </p>
          </div>
          <a href="#feed" className="inline-flex shrink-0 items-center gap-1 text-sm font-bold text-primary-600 hover:text-primary-700 cursor-pointer">
            想知道大家都在玩什么？
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {gameCards.map((g) => (
            <a
              key={g.title}
              href="#feed"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-36 w-full overflow-hidden md:h-40">
                <img
                  src={g.image}
                  alt={g.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-bold text-primary-700">
                  <i className="ri-vip-crown-line text-sm" aria-hidden="true" />
                  {g.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-lg font-black text-foreground-950">{g.title}</h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-[13px]">
                  {g.desc}
                </p>
                <dl className="mt-4 space-y-1 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <div className="flex items-center justify-between">
                    <dt className="flex items-center gap-1.5">
                      <i className="ri-question-answer-line text-sm text-primary-500" aria-hidden="true" />
                      体量
                    </dt>
                    <dd className="font-medium text-foreground-800">{g.qcount}</dd>
                  </div>
                  <div className="flex items-center justify-between">
                    <dt className="flex items-center gap-1.5">
                      <i className="ri-team-line text-sm text-primary-500" aria-hidden="true" />
                      人气
                    </dt>
                    <dd className="font-medium text-foreground-800">{g.players}</dd>
                  </div>
                </dl>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{g.level}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-bold text-primary-600 group-hover:gap-1.5 transition-all">
                    去玩
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}